<template>
  <div>
    <v-card-title class="pb-0 pt-2 green darken-4">
      <p class="body-1 font-weight-medium">
        Year Range
      </p>
    </v-card-title>

    <v-divider></v-divider>
    <v-card-text>
      <v-row>
        <v-col cols="6">
          <v-menu
            ref="menuFrom"
            v-model="menuFrom"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="filters.yearFrom"
                outlined
                label="From Year"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filters.yearFrom"
              :active-picker.sync="activePickerFrom"
              :max="new Date().getFullYear().toString()"
              min="2020"
              no-title
              @click:year="onYearFromChange"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="6">
          <v-menu
            ref="menuTo"
            v-model="menuTo"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="filters.yearTo"
                outlined
                label="To Year"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filters.yearTo"
              :active-picker.sync="activePickerTo"
              :max="new Date().getFullYear().toString()"
              min="2020"
              no-title
              @click:year="onYearToChange"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      menuFrom: false,
      menuTo: false,
      activePickerFrom: null,
      activePickerTo: null,
      filters: {
        yearFrom: '',
        yearTo: '',
      },
    }
  },
  watch: {
    menuFrom() {
      setTimeout(() => { this.activePickerFrom = 'YEAR' })
    },
    menuTo() {
      setTimeout(() => { this.activePickerTo = 'YEAR' })
    },
  },
  mounted() {
    this.filters.yearFrom = (moment().year() - 1).toString()
    this.filters.yearTo = moment().year().toString()
    this.emitChange()
  },
  methods: {
    onYearFromChange(value) {
      this.menuFrom = false
      this.filters.yearFrom = value.toString()
      this.emitChange()
    },
    onYearToChange(value) {
      this.menuTo = false
      this.filters.yearTo = value.toString()
      this.emitChange()
    },
    emitChange() {
      this.$emit('year-range-change', {
        filters: {
          yearFrom: this.filters.yearFrom,
          yearTo: this.filters.yearTo,
        },
        label: `${this.filters.yearFrom} - ${this.filters.yearTo}`,
      })
    },
  },
}
</script>
